import { render, staticRenderFns } from "./leftService.vue?vue&type=template&id=2ed1e27a&"
import script from "./leftService.vue?vue&type=script&lang=js&"
export * from "./leftService.vue?vue&type=script&lang=js&"
import style0 from "./leftService.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports